export default __webpack_public_path__ + "static/media/033-psychology.373631b6.svg";